import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const Tumblr = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13.3863437,20 C10.9804192,20 9.18702146,18.7620936 9.18702146,15.8003766 L9.18702146,11.057211 L7,11.057211 L7,8.48891678 C9.40692858,7.86403916 10.413079,5.79329735 10.5295594,4 L13.0278649,4 L13.0278649,8.07229823 L15.9428894,8.07229823 L15.9428894,11.057211 L13.0278649,11.057211 L13.0278649,15.1873478 C13.0278649,16.4253546 13.6524413,16.8532195 14.6475461,16.8532195 L16.0593699,16.8532195 L16.0593699,20 L13.3863437,20", fillRule: "evenodd" })));
};
Tumblr.displayName = 'Tumblr';
export default Tumblr;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Tumblr.js.map